export default __webpack_public_path__ + "static/isabella-silveira-de-souza-1c1f75a6a71da149c3ce5afca8d61344.jpg";